import request from '../api';

// 修改用户知识库名称
export function updateUserKnowledgeName(data) {
  return request.post('/app/userKnowledge/updateUserKnowledgeName',data)
}

// 获取App用户知识库分页列表
export function getAppUserKnowledgePage(data) {
  return request.post(`/app/userKnowledge/getAppUserKnowledgePage`,data)
}


// 获取App用户知识库详情
export function getAppUserKnowledge(id) {
  return request.post(`/app/userKnowledge/getAppUserKnowledge/${id}`,{})
}


// 删除用户知识库
export function deleteUserKnowledge(id) {
  return request.post(`/app/userKnowledge/deleteUserKnowledge/${id}`,{})
}


// 添加用户知识库
export function addUserKnowledge(data) {
  return request.post(`/app/userKnowledge/addUserKnowledge`,data)
}


// 获取官方知识库列表
export function getOfficialKnowledgeList() {
  return request.post(`/app/officialKnowledge/getOfficialKnowledgeList`,{})
}

// 获取App官方知识库分页列表
export function getAppOfficialKnowledgePage(data) {
  return request.post(`/app/officialKnowledge/getAppOfficialKnowledgePage`,data)
}

// 获取App官方知识库详情
export function getAppOfficialKnowledge(id) {
  return request.post(`/app/officialKnowledge/getAppOfficialKnowledge/${id}`,{})
}


// 获取App知识库分类详情
export function getAppKnowledgeType(id) {
  return request.post(`/app/knowledgeType/getAppKnowledgeType/${id}`,{})
}


// 获取知识库分类列表
export function getKnowledgeTypeList() {
  return request.post(`/app/knowledgeType/getKnowledgeTypeList`,{})
}

// 获取App知识库内容分页列表
export function getAppKnowledgeContentPage(data) {
  return request.post(`/app/knowledgeContent/getAppKnowledgeContentPage`,data)
}

// 获取App知识库内容详情
export function getAppKnowledgeContent(id) {
  return request.post(`/app/knowledgeContent/getAppKnowledgeContent/${id}`,{})
}

// 删除知识库内容
export function deleteKnowledgeContent(id) {
  return request.post(`/app/knowledgeContent/deleteKnowledgeContent/${id}`,{})
}

// 添加知识库内容
export function addKnowledgeContent(data) {
  return request.post(`/app/knowledgeContent/addKnowledgeContent`,data)
}
